import { GraphQLReturn, graphQLSelector } from '@cherre-frontend/data-fetching';
import { graphql } from 'react-relay';
import { useGetMappingFieldCustomAttributesQuery } from './__generated__/useGetMappingFieldCustomAttributesQuery.graphql';

export const $getMappingFieldCustomAttributes = graphQLSelector({
  query: graphql`
    query useGetMappingFieldCustomAttributesQuery(
      $organizationId: Int!
      $mappingFieldName: String!
    ) {
      sys_mapping_fields(
        where: {
          is_active: { _eq: true }
          organization_id: { _eq: $organizationId }
          mapping_field_name: { _eq: $mappingFieldName }
        }
      ) {
        custom_attributes
      }
    }
  ` as GraphQLReturn<useGetMappingFieldCustomAttributesQuery>,
  mapResponse: (resp) => {
    return resp.sys_mapping_fields;
  },
});
